import Loading from "../Loading";

export const VerifyChecking = ({ text }: { text: string }) => {
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-[#141517]/80 flex flex-col items-center justify-center h-full gap-6">
      <div className="text-size-14 font-medium text-[#fff]">{text}</div>
      <Loading />
    </div>
  );
};
